const LangSignIn = {
	"signIn.signUp._notAMember": ["Not a member?", "Chưa phải là thành viên?"],
	"signIn.signUp._reward": ["JOIN STARBUCKSREWARDS", "THAM GIA STARBUCKSREWARDS"],
	"signIn.signUp._description": [
		"<p>With a Starbucks Rewards account, you can register your Starbucks Card, manage your account and participate in Starbucks Rewards<sup>TM</sup> program.</p><p>Pay with your registered Starbucks Rewards<sup>TM</sup> Card in any participating Starbucks store to earn Stars.</p><p>Earn one Star for every VND 40,000 you spend.</p><p>Collect 100 Stars within one year to reach Gold Status.</p>",
		"<p>Khi bạn đăng ký thành công thẻ Starbucks, bạn đã là thành viên của chương trình Starbucks Rewards<sup>TM</sup>.</p><p>Thanh toán bằng thẻ Starbucks Rewards<sup>TM</sup> khi thực hiện bất kỳ giao dịch tại cửa hàng Starbucks để tích lũy điểm ngôi sao.</p><p>Bạn sẽ được một ngôi sao điểm thưởng với mỗi chi tiêu VND 40,000.</p><p>Tích lũy 100 ngôi sao điểm thưởng trong một năm để được nâng lên hạng thẻ Vàng.</p>",
	],
	"signIn.form._forgotPasswordOrEmail": ["Forgot your ", "Quên "],
	"signIn.form._email": ["email", "email"],
	"signIn.form._password": ["password", "mật khẩu"],
	"signIn.form._or": ["or", "hoặc"],
	"signIn.form._invalidCredential": [
		"Please check your sign-in information and try again. 5 failed attempts before your account will be temporarily locked for 10 mins",
		"Địa chỉ email hoặc mật khẩu không đúng, vui lòng thử lại. Tài khoản của bạn sẽ bị tạm khóa trong vòng 10 phút nếu bạn nhập sai thông tin quá 5 lần.",
	],
	"signIn.signUp._pay": ["Pay with your phone", "Thanh toán với ứng dụng"],
	"signIn.signUp._earn": ["Earn free Drinks and Food", "Bánh và nước miễn phí"],
	"signIn.signUp._exclusive": ["Exclusive Member Offer", "Ưu đãi đặc biệt"],
	"signIn.signUp._exclusive": ["Exclusive Member Offer", "Ưu đãi đặc biệt"],
	"signIn.signUp.bg.title": [
		"SAY HELLO TO MAGICAL REWARDS",
		"SAY HELLO TO MAGICAL REWARDS",
	],
	"signIn.signUp.bottom.sub1": [
		"With a Starbucks Rewards account, you can register your Starbucks Card, manage your account and participate in Starbucks Rewards™ program.",
		"Khi bạn đăng ký thành công thẻ Starbucks, bạn đã là thành viên của chương trình Starbucks Rewards™️.",
	],
	"signIn.signUp.bottom.sub1": [
		"With a Starbucks Rewards account, you can register your Starbucks Card, manage your account and participate in Starbucks Rewards™ program.",
		"Khi bạn đăng ký thành công thẻ Starbucks, bạn đã là thành viên của chương trình Starbucks Rewards™️.",
	],
	"signIn.signUp.bottom.sub2": [
		"Pay with your registered Starbucks Rewards™️ account any way you like and earn Rewards",
		"Thanh toán với tài khoản Starbucks Rewards™️ đã đăng ký theo cách bạn muốn và tận hưởng các ưu đãi thành viên",
	],
	"signIn.signUp.bottom.sub3": [
		"Collect Stars to reach Gold Status faster with the mobile app:",
		"Tích lũy Điểm ngôi sao và nâng hạng thẻ nhanh chóng hơn với ứng dụng điện thoại:",
	],
	"signIn.signUp.order.via.mobile": [
		"Order via mobile and pick up at store",
		"Đặt món qua ứng dụng và đến nhận tại cửa hàng",
	],
	"signIn.signUp.favorites.delivered": [
		"Get your favorites delivered to you",
		"Thức uống yêu thích của bạn sẽ được giao đến tận nơi",
	],
	"signIn.signUp.exclusive.feature": [
		"Experience more exclusive feature in Starbucks Vietnam app",
		"Trải nghiệm các tính năng khác chỉ dành cho thành viên trên ứng dụng Starbucks Vietnam",
	],
	"signIn.signUp.exclusive.join.now": ["Join now", "Tham gia ngay"],
	"signIn.signUp.exclusive.collect": [
		"Collect 100 Stars within one year to reach Gold Status.",
		"Tích lũy 100 điểm ngôi sao trong một năm để được nâng lên hạng thẻ Vàng.",
	],
}

export default LangSignIn



// WEBPACK FOOTER //
// ./src/resources/pages/LangSignIn.js